import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { Button } from 'dibs-elements/exports/Button';
import scrollIntoView from 'scroll-into-view';

import styles from './Header.scss';

class Header extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();
        const element = document.querySelector('.js-sourcing-form');
        if (element) {
            scrollIntoView(element, { time: 1000 });
        }
    }

    render() {
        return (
            <div className="rowFlex rowWrapper">
                <div className={styles.backgroundImage}>
                    <div className={styles.boxWrapper}>
                        <div className={styles.innerWrapper}>
                            <BarHeader
                                title={
                                    <FormattedMessage
                                        id="abt.sourcing.header.header"
                                        defaultMessage="Free Sourcing Service for Trade"
                                    />
                                }
                            />
                            <div className={styles.subheader}>
                                <FormattedMessage
                                    id="abt.sourcing.header.subheader"
                                    defaultMessage="We're committed to your success as a Trade member, and that’s why we offer our free sourcing service, so you can save time and focus on your work."
                                />
                            </div>
                            <Button
                                type="primary"
                                onClick={this.handleClick}
                                className={styles.cta}
                            >
                                <FormattedMessage
                                    id="abt.sourcing.header.cta"
                                    defaultMessage="Get Started"
                                />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;
